<template lang="pug">
section.visible__layout
  h1.h1-title Абонементы

  spacer(size="40px")

  .profile-info.early-booking(v-if="profile")
    .col-side
      .row.code
        .col
          .label
            | КОД АБОНЕМЕНТА
            sup *
          input.input(v-model="code")
      .row
        .col
          .label
            | Имя
            sup *
          input.input(v-model="profile.firstName")
      .row
        .col
          .label
            | Фамилия
            sup *
          input.input(v-model="profile.lastName")
      .row
        .col
          .label Отчество
          input.input(v-model="profile.middleName")
      .row
        .col
          .label
            | Пол
            sup *
          select.input(v-model="profile.gender")
            option(:value="1") Мужской
            option(:value="0") Женский
      .row
        .col
          .label
            | Дата рождения
            sup *
      .row
        .col
          select.input(name="day", v-model="activeDob.day")
            option(v-for="(day, index) in dates.days", :value="index") {{day}}
        .col
          select.input(name="mounth", v-model="activeDob.mounth")
            option(v-for="(mounth, index) in dates.mounths", :value="index") {{mounth}}
        .col
          select.input(name="year", v-model="activeDob.year")
            option(v-for="(year, index) in dates.years", :value="index") {{year}}
      .row
        .col
          .label
            | Город
            sup *
          select.input(name="city", v-model="profile.cityId")
            option(v-for="city in cities", :value="city.id") {{city.name}}
      .row
        .col
          .label
            | Email
            sup *
          input.input(v-model="profile.email")
      .row
        .col
          .label
            button.btn(@click="sendCode()") Оформить
    //- .col-side
      picture
        img(src="~@/assets/img/dinbrest.jpg")
</template>

<script>
import { mapGetters } from 'vuex';
import API from '@/api/api';

export default {
  data() {
    return {
      code: null,
      profile: null,
      cities: null,
      activeDob: {
        day: null,
        mounth: null,
        year: null,
      },
      valid: false,
    };
  },
  mounted() {
    this.initDates();
    this.getCities();
    this.getInfo();
  },
  computed: {
    ...mapGetters({
      isLogged: 'user/isLogged',
    }),
  },
  watch: {
    isLogged(val) {
      this.logged = val;
      if (this.logged) {
        this.getCities();
        this.getInfo();
      }
    },
  },
  methods: {
    initDates() {
      if (!this.dates) {
        this.dates = {
          days: [],
          mounths: [],
          years: [],
        };
      }
      for (let i = new Date().getFullYear() - 99; i <= new Date().getFullYear(); i += 1) {
        this.dates.years.push(String(i));
      }
      for (let i = 1; i < 32; i += 1) {
        this.dates.days.push(String(i));
      }
      this.dates.mounths = ['янв.', 'фев.', 'мар.', 'апр.', 'май.', 'июн.', 'июл.', 'авг.', 'сен.',
        'окт.', 'ноя.', 'дек.'];
    },

    async getInfo() {
      const data = await API.getUserInfo((error) => {
        // ERROR SCENARIUS
        console.error('Error', error);
      });
      if (data && data.id) {
        console.log(data);
        this.profile = data;
        this.getDob(data.dob);
      }
    },

    async getCities() {
      const data = await API.getCities();
      if (data.data) {
        this.cities = data.data;
      }
    },

    getDob(date) {
      if (date) {
        const dob = date.split('-');
        setTimeout(() => {
          this.activeDob.day = parseFloat(dob[2]) - 1;
          this.activeDob.mounth = parseFloat(dob[1]) - 1;
          this.activeDob.year = this.dates.years.indexOf(dob[0]);
        }, 500);
      } else {
        this.activeDob = {
          day: 1,
          mounth: 0,
          year: String(new Date().getFullYear()),
        };
      }
    },

    validate() {
      if (!this.code || !this.code.length) {
        this.valid = false;
        global.alert('введите код');
      } else if (!this.profile.cityId) {
        this.valid = false;
        global.alert('выберите город');
      } else if (!this.profile.firstName) {
        this.valid = false;
        global.alert('введите имя');
      } else if (!this.profile.lastName) {
        this.valid = false;
        global.alert('введите фамилию');
      } else if (!this.profile.cityId) {
        this.valid = false;
        global.alert('выберите город');
      } else if (!this.profile.email) {
        this.valid = false;
        global.alert('введите email');
      } else {
        this.valid = true;
      }
    },

    async sendCode() {
      this.validate();
      if (this.valid) {
        console.log('valid');
        const data = await API.setEarlyCode({
          booking_code: this.code,
          user: this.setParamsProfile(),
        }, (error) => {
          global.alert(error.response.data.errors.code ? error.response.data.errors.code[0]
            : 'Извините, произошла ошибка, попробуйте еще раз');
          console.log('error', error);
        });
        if (data && data.id) {
          global.alert('Код успешно активирован!');
          this.$router.push({ name: 'payment', params: { id: data.id } });
        }
      }
    },

    setParamsProfile() {
      return {
        email: this.profile.email,
        last_name: this.profile.lastName,
        first_name: this.profile.firstName,
        middle_name: this.profile.middleName,
        dob: this.setDob(),
        city_id: this.profile.cityId,
        gender: this.profile.gender,
        sms_subscribe: this.profile.smsSubscribe,
        email_subscribe: this.profile.emailSubscribe,
      };
    },

    setDob() {
      return `${this.dates.years[this.activeDob.year]}-${this.setDobMounth(
        this.activeDob.mounth,
      )}-${this.dates.days[this.activeDob.day]}`;
    },

    setDobMounth(mounth) {
      mounth += 1;
      return mounth.length === 1 ? `0${mounth}` : mounth;
    },
  },
};
</script>

<style lang="scss" scoped>
.early-booking {
  display: flex;
  .col-side {
    min-width: 28rem;
  }
}
.row {
  padding: 0 1rem;
  &.code {
    padding-top: 1rem;
    background-color: #6400ac;
    margin-bottom: 1rem;
    .label {
      color: #fff;
    }
  }
  sup {
    &:before {
      content: ' ';
    }
    color: red;
  }
}
</style>
